import { FormWrapper } from '@sleepstation/components-form'
import { defaultDarkerTheme } from '@sleepstation/themes-public-site'
import React, { useEffect } from 'react'
import { useMutation } from 'urql'
import { useNavigate } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import { isNotNil } from 'ramda'
import HubEpworthQuestionnairePage from './HubEpworthQuestionnairePage'
import { CreateQuestionnaireResponse } from '../../../graphql/documents'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const RESULTS_PATH = `/hub/are-you-getting-enough-sleep/results/`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const HubEpworthQuestionnaireModule = () => {
  const navigate = useNavigate()
  const [questionnaireResult, createQuestionnaireResponse] = useMutation(
    CreateQuestionnaireResponse
  )

  useEffect(() => {
    if (isNotNil(questionnaireResult.data)) {
      navigate(RESULTS_PATH)
    }
  }, [questionnaireResult.data, navigate])

  return (
    <ThemeProvider theme={defaultDarkerTheme}>
      <FormWrapper
        wrappedComponent={HubEpworthQuestionnairePage}
        onSuccess={createQuestionnaireResponse}
      />
    </ThemeProvider>
  )
}

export default HubEpworthQuestionnaireModule
